import React from "react"
import {
  ExampleBlockquote,
  RecommendedPostBlockquote,
  TermClusterBlockquote,
  TipBlockquote,
  WarningBlockquote,
  WistiaEmbed,
} from "./quote-components"
import Children from "react-children-utilities"

import { BlogInfoBox } from "components/blog-components"

const component_map = {
  achtung: { Component: WarningBlockquote, keyword: "Achtung" },
  warnung: { Component: WarningBlockquote, keyword: "Warnung" },
  wichtig: { Component: WarningBlockquote, keyword: "Wichtig" },
  tipp: { Component: TipBlockquote, keyword: "Tipp" },
  tip: { Component: TipBlockquote, keyword: "Tipp" },
  hinweis: { Component: TipBlockquote, keyword: "Hinweis" },
  beispiel: { Component: ExampleBlockquote, keyword: "Beispiel" },
  "rechtlicher hinweis": {
    Component: BlogInfoBox,
    keyword: "Rechtlicher Hinweis",
  },
  begriffscluster: {
    Component: TermClusterBlockquote,
    keyword: "Begriffscluster",
  },
  wistia: {
    Component: WistiaEmbed,
  },
  "empfohlener blogpost": {
    Component: RecommendedPostBlockquote,
    keyword: "Empfohlener Blogpost",
  },
}

export const CustomConentBlockquote = ({ children }) => {
  const text_types = ["span", "p"]

  const raw_text = Children.onlyText(
    Children.filter(children, (child) => text_types.includes(child.type))
  )

  const longest_key = Math.max(
    ...Object.entries(component_map).map(([el]) => el.length)
  )

  let splitpoint = raw_text.indexOf(": ")
  const alt_splitpoint = raw_text.indexOf(":\n")

  if (splitpoint < 0 || splitpoint > longest_key) {
    if (alt_splitpoint < 0) {
      return <blockquote className="my-4">{children}</blockquote>
    }
    splitpoint = alt_splitpoint
  }
  const key = raw_text.slice(0, splitpoint).toLowerCase()
  const text = raw_text.slice(splitpoint + 2)

  const { Component, keyword } = component_map[key] || {}

  return !!Component ? (
    <Component {...{ text, keyword, content: children, type: key }} />
  ) : (
    <blockquote className="my-4">{children}</blockquote>
  )
}
